// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labels__header[data-v-0bd5f0d9]{display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
